export default {
    ActiveDisplay(state, val){state.display = val},
    ActiveLateral(state, val){ state.lateralShow = val;},
    set_displayEdit(state, val){
        state.displayEdit = val;
    },	
}
